export default __webpack_public_path__ + "static/media/Abuja5.568ad6c9.jpg";